import CateringSite from './CateringSite'

export default CateringSite
